import React from 'react';
import ShimmerEffect from './ShimmerEffect';

const CaseCardSkeleton: React.FC = () => {
  return (
    <ShimmerEffect>
      <div className="card p-6 bg-white">
        {/* Header with title and icon placeholders */}
        <div className="flex items-start justify-between mb-4">
          <div className="flex-1">
            <div className="flex items-center space-x-2 mb-2">
              <div className="h-7 w-48 bg-gray-200 rounded"></div>
            </div>
            <div className="h-4 w-24 bg-gray-200 rounded"></div>
          </div>
          <div className="flex space-x-2">
            <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
          </div>
        </div>

        {/* Info section with multiple lines */}
        <div className="space-y-2 text-sm mb-4">
          {/* Line 1: Level - Subject */}
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 bg-gray-200 rounded flex-shrink-0"></div>
            <div className="h-4 w-40 bg-gray-200 rounded"></div>
          </div>
          
          {/* Line 2: Location */}
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 bg-gray-200 rounded flex-shrink-0"></div>
            <div className="h-4 w-48 bg-gray-200 rounded"></div>
          </div>
          
          {/* Line 3: Frequency */}
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 bg-gray-200 rounded flex-shrink-0"></div>
            <div className="h-4 w-44 bg-gray-200 rounded"></div>
          </div>
          
          {/* Line 4: Tuition Type */}
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 bg-gray-200 rounded flex-shrink-0"></div>
            <div className="h-4 w-32 bg-gray-200 rounded"></div>
          </div>
        </div>

        {/* Price and Button section */}
        <div className="flex items-center justify-between pt-3 border-t border-gray-200">
          <div>
            <div className="h-6 w-20 bg-gray-200 rounded mb-1"></div>
          </div>
          <div className="h-10 w-28 bg-gray-200 rounded"></div>
        </div>

        {/* Posted date */}
        <div className="mt-3">
          <div className="h-3 w-32 bg-gray-200 rounded"></div>
        </div>
      </div>
    </ShimmerEffect>
  );
};

export default CaseCardSkeleton;
